export const InsuranceType = {
  1: {
    label: 'Particular',
  },
  2: {
    label: 'Empresarial',
  },
  Particular: {
    id: 1,
  },
  Empresarial: {
    id: 2,
  },
}

export default InsuranceType
